import { useMutation } from '@tanstack/react-query';
import { format } from 'date-fns';

import { endpoints } from 'global/endpoints';
import downloadHttp from 'utils/reportDownloads';

interface IDownloadTimeOffReportsCSVPostData {
  start_date: string;
  end_date: string;
  category_ids?: number[]; // Optional - only included if categories are selected
}

const downloadReportByJobsTotalOnlyCSV = (postData: IDownloadTimeOffReportsCSVPostData) => {
  const newEndpoints = endpoints.reports.reportByJobsTotalOnlyCSv;
  const filename = `jobs-totals-reports-${format(new Date(), 'yMdHms')}.csv`;

  return downloadHttp().lpostcsv(newEndpoints, postData, filename);
};

export function useDownloadReportByJobsTotalOnlyCSV() {
  return useMutation({ mutationFn: downloadReportByJobsTotalOnlyCSV });
}
